import { createFileRoute } from '@tanstack/react-router';
import DripContactPage from '../../views/dashboard-drip/contacts/contact';

export const Route = createFileRoute('/dashboard/drip/contacts_/$uuid')({
  component: DripContactPage,
});
